module.exports = " <div id=app> <hello :msg=msg></hello> <display></display> <increase></increase> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 13
 ** module chunks = 1
 **/